module.exports = __webpack_public_path__ + "static/img/horror-hand-v4.aec8ddd1.png";